import React from "react";

import tw from "twin.macro";
import clsx from "clsx";

import {
  BannerCarousel,
  Banner as BannerSwiper,
  CarouselSection,
} from "@bared/ui";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { withBanner, type BannerOutputProps } from "./withBanner";

import { Link } from "~/components/Link";
import { AnalyticsCreativeSlot } from "~/components/AnalyticsCreativeSlot";

type OverlayProps = {
  rgb?: {
    r: string;
    g: string;
    b: string;
    a: string;
  };
};

const Overlay = styledWithInvalidProps("div")(({ rgb }: OverlayProps) => [
  tw`absolute z-10 w-full h-full`,
  rgb ? `background-color: rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` : null,
]);

const Banner = ({
  bannerContent,
  transparentHeader,
  anchorId,
}: BannerOutputProps) => (
  <>
    {bannerContent && bannerContent?.length > 0 ? (
      <BannerCarousel
        ariaLabel="Banner Swipers"
        data-component-type="section-banner"
        transparentHeader={transparentHeader}
        className={clsx(
          bannerContent.length > 1 && "overflow-hidden pb-mini",
          "hide-scrollbar",
        )}
      >
        {bannerContent.map((banner, index) => {
          const {
            desktopContent,
            desktopContentAlignment,
            desktopImage,
            desktopImageAspectRatio,
            desktopImagelink,
            desktopVideoUrl,
            mobileContent,
            mobileContentAlignment,
            mobileImage,
            mobileImageAspectRatio,
            mobileVideoUrl,
            textColor,
            maxContentWidth,
            cta,
            overlayBackgroundColour,
          } = banner;

          const inner = (
            <BannerSwiper
              desktopContent={desktopContent}
              desktopContentAlignment={desktopContentAlignment}
              desktopImage={desktopImage}
              desktopImageAspectRatio={desktopImageAspectRatio}
              desktopImagelink={desktopImagelink}
              desktopVideoUrl={desktopVideoUrl}
              mobileContent={mobileContent}
              mobileContentAlignment={mobileContentAlignment}
              mobileImage={mobileImage}
              mobileImageAspectRatio={mobileImageAspectRatio}
              mobileVideoUrl={mobileVideoUrl}
              textColor={textColor}
              maxContentWidth={maxContentWidth}
              cta={cta}
            >
              <Overlay
                rgb={overlayBackgroundColour?.rgb}
                className="top-zero"
              />
            </BannerSwiper>
          );

          return (
            <CarouselSection index={index} key={`banner-swiper-${index}`}>
              <AnalyticsCreativeSlot
                name={`${anchorId ?? "Banner"} - Section ${index + 1}`}
              >
                {desktopImagelink?.url ? (
                  <Link
                    href={desktopImagelink.url}
                    data-promo-name="Banner Background"
                  >
                    {inner}
                  </Link>
                ) : (
                  inner
                )}
              </AnalyticsCreativeSlot>
            </CarouselSection>
          );
        })}
      </BannerCarousel>
    ) : null}
  </>
);

export default withBanner(Banner);
